/* ============================================================
   YANIKO GOLD — Collection (catalog) behaviour
   Filter drawer, floating bar, sort, AJAX "load more", description
   toggle. Shopify does the actual filtering/sorting server-side via
   the filter <form> and sort_by; this only handles UI + progressive
   "load more". Scoped to [data-yg-collection].
   ============================================================ */
(function () {
  "use strict";

  function init(root) {
    if (!root || root.__ygColInit) return;
    root.__ygColInit = true;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---------- Reveal the initial product cards (they start hidden via CSS) ---------- */
    function revealCards(scope) {
      var cards = (scope || root).querySelectorAll(".cl-grid .p-card:not(.is-in)");
      if (!cards.length) return;
      if (reduceMotion || !("IntersectionObserver" in window)) {
        cards.forEach(function (c) { c.classList.add("is-in"); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
      }, { threshold: 0.08, rootMargin: "0px 0px -40px 0px" });
      cards.forEach(function (c) { io.observe(c); });
      // safety net: never leave cards invisible
      setTimeout(function () { cards.forEach(function (c) { c.classList.add("is-in"); }); }, 1200);
    }
    revealCards(root);

    /* ---------- Filter drawer ---------- */
    var drawer = root.querySelector(".filters");
    var scrim = root.querySelector(".cl-scrim");
    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add("is-on"); drawer.setAttribute("aria-hidden", "false");
      if (scrim) scrim.classList.add("is-on");
      document.body.style.overflow = "hidden";
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove("is-on"); drawer.setAttribute("aria-hidden", "true");
      if (scrim) scrim.classList.remove("is-on");
      document.body.style.overflow = "";
    }
    root.addEventListener("click", function (e) {
      if (e.target.closest("[data-filter-open]")) { e.preventDefault(); openDrawer(); }
      else if (e.target.closest("[data-filter-close]")) { closeDrawer(); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

    /* ---------- Floating filter/sort bar (reveal after scrolling past the toolbar) ---------- */
    var floatbar = root.querySelector(".cl-floatbar");
    var toolbar = root.querySelector(".toolbar");
    if (floatbar && toolbar) {
      var onScroll = function () {
        var r = toolbar.getBoundingClientRect();
        floatbar.classList.toggle("is-on", r.bottom < 0);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    /* ---------- Sort: navigate with sort_by, preserving filters ---------- */
    root.querySelectorAll("[data-sort]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sel.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    });

    /* ---------- Description toggle ---------- */
    var descToggle = root.querySelector("[data-desc-toggle]");
    var desc = root.querySelector("[data-desc]");
    if (descToggle && desc) {
      descToggle.addEventListener("click", function () {
        var open = desc.classList.toggle("is-open");
        descToggle.textContent = open ? "Скрий" : "Прочети още";
      });
    }

    /* ---------- AJAX "load more" ---------- */
    var moreBtn = root.querySelector("[data-more]");
    var grid = root.querySelector("[data-grid]");
    var moreBar = root.querySelector("[data-more-bar]");
    var moreInfo = root.querySelector("[data-more-info]");
    var loadedMore = false;
    if (moreBtn && grid) {
      moreBtn.addEventListener("click", function (e) {
        var next = moreBtn.getAttribute("href") || moreBtn.getAttribute("data-next");
        if (!next) return;
        e.preventDefault();
        moreBtn.classList.add("is-loading");
        moreBtn.textContent = "Зареждане…";
        fetch(next, { headers: { "X-Requested-With": "XMLHttpRequest" } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var newGrid = doc.querySelector("[data-grid]");
            if (newGrid) {
              Array.prototype.slice.call(newGrid.children).forEach(function (card) {
                if (card.classList && card.classList.contains("p-card")) {
                  grid.appendChild(card);
                  if (!reduceMotion) { requestAnimationFrame(function () { card.classList.add("is-in"); }); }
                  else { card.classList.add("is-in"); }
                }
              });
            }
            if (window.__ygApplyWish) window.__ygApplyWish();
            loadedMore = true;
            var newMore = doc.querySelector("[data-more]");
            var newInfo = doc.querySelector("[data-more-info]");
            var newBar = doc.querySelector("[data-more-bar]");
            if (newInfo && moreInfo) moreInfo.textContent = newInfo.textContent;
            if (newBar && moreBar) moreBar.style.width = newBar.style.width;
            if (newMore && newMore.getAttribute("href")) {
              moreBtn.setAttribute("href", newMore.getAttribute("href"));
              moreBtn.classList.remove("is-loading");
              moreBtn.textContent = "Зареди още";
            } else {
              var wrap = root.querySelector("[data-loadwrap]");
              moreBtn.remove();
              if (moreBar && moreBar.parentNode) moreBar.parentNode.style.display = "none";
            }
          })
          .catch(function () {
            moreBtn.classList.remove("is-loading");
            moreBtn.textContent = "Зареди още";
            window.location.href = next;
          });
      });
    }

    /* ---------- Restore loaded products + scroll position on BACK navigation ----------
       Keeps the customer where they were after viewing a product, instead of
       sending them back to the top of the catalogue. State is kept per
       collection+filters URL in sessionStorage. ---------------------------------------- */
    if (grid) {
      if ("scrollRestoration" in history) {
        try { history.scrollRestoration = "manual"; } catch (e) {}
      }
      var stateKey = function () {
        var u = new URL(window.location.href);
        u.searchParams.delete("page");
        return "ygcol:" + u.pathname + u.search;
      };
      var saveState = function () {
        try {
          sessionStorage.setItem(stateKey(), JSON.stringify({
            html: loadedMore ? grid.innerHTML : "",
            next: (moreBtn && moreBtn.parentNode) ? (moreBtn.getAttribute("href") || "") : "done",
            info: moreInfo ? moreInfo.textContent : "",
            barW: moreBar ? moreBar.style.width : "",
            y: window.pageYOffset || document.documentElement.scrollTop || 0
          }));
        } catch (e) {}
      };
      window.addEventListener("pagehide", saveState);
      // extra safety: also save the moment a product link is clicked
      grid.addEventListener("click", function (e) { if (e.target.closest("a[href]")) saveState(); }, true);

      var navType = "";
      try {
        var ne = performance.getEntriesByType && performance.getEntriesByType("navigation");
        if (ne && ne[0]) navType = ne[0].type;
        else if (performance.navigation && performance.navigation.type === 2) navType = "back_forward";
      } catch (e) {}

      if (navType === "back_forward") {
        var raw = null;
        try { raw = sessionStorage.getItem(stateKey()); } catch (e) {}
        if (raw) {
          try {
            var s = JSON.parse(raw);
            if (s && s.html) {
              grid.innerHTML = s.html;
              loadedMore = true;
              Array.prototype.forEach.call(grid.querySelectorAll(".p-card"), function (c) { c.classList.add("is-in"); });
              if (moreBtn) {
                if (s.next && s.next !== "done") { moreBtn.setAttribute("href", s.next); }
                else { moreBtn.remove(); if (moreBar && moreBar.parentNode) moreBar.parentNode.style.display = "none"; }
              }
              if (moreInfo && s.info) moreInfo.textContent = s.info;
              if (moreBar && s.barW) moreBar.style.width = s.barW;
              if (window.__ygApplyWish) window.__ygApplyWish();
            }
            if (s && typeof s.y === "number") {
              var y = s.y;
              requestAnimationFrame(function () { requestAnimationFrame(function () { window.scrollTo(0, y); }); });
            }
          } catch (e) {}
        }
      }
    }
  }

  function boot() {
    document.querySelectorAll("[data-yg-collection]").forEach(init);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelectorAll) e.target.querySelectorAll("[data-yg-collection]").forEach(init);
  });
})();
